import { render, staticRenderFns } from "./TrademarkObjectionToUsCaseDecisionList.vue?vue&type=template&id=5ed57c96&"
import script from "./TrademarkObjectionToUsCaseDecisionList.vue?vue&type=script&lang=js&"
export * from "./TrademarkObjectionToUsCaseDecisionList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkObjectionToUsCaseDecisionList.vue?vue&type=style&index=0&id=5ed57c96&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports